import 'whatwg-fetch';
import { csrfFromDom } from 'common/utils/server';

export const TOGGLE_CATEGORY_FORM = 'TOGGLE_CATEGORY_FORM';
export const COACHING_NOTES_REQUEST = 'COACHING_NOTES_REQUEST';
export const COACHING_NOTES_ERROR = 'COACHING_NOTES_ERROR';
export const COACHING_NOTES_FETCH_SUCCESS = 'COACHING_NOTES_FETCH_SUCCESS';

export function toggleForm() {
  return { type: TOGGLE_CATEGORY_FORM };
}

function companySettingRequest() {
  return { type: COACHING_NOTES_REQUEST };
}

function companySettingSuccess(coachingNotes) {
  return { type: COACHING_NOTES_FETCH_SUCCESS, coachingNotes };
}

export function companySettingError(error) {
  return { type: COACHING_NOTES_ERROR, error };
}

export function fetchCoachingNotesSettings(showArchived = false) {
  return function fetchData(dispatch) {
    dispatch(companySettingRequest());

    return fetch(
      `/admin/company/coaching_notes?show_archived=${showArchived}`,
      {
        method: 'GET',
        credentials: 'include',
      }
    )
      .then(response => response.json())
      .then(json => {
        dispatch(companySettingSuccess(json));
      })
      .catch(error => {
        dispatch(companySettingError(error));
      });
  };
}

function updateCoachingNotesPermissions(status) {
  return function fetchData(dispatch) {
    dispatch(companySettingRequest());
    const data = { permissions: status };

    return fetch('/admin/company/coaching_notes/', {
      method: 'PUT',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfFromDom(),
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(json => {
        dispatch(companySettingSuccess(json));
      })
      .catch(error => {
        dispatch(companySettingError(error));
      });
  };
}

export function enableCoachingNotesPermissions() {
  return dispatch => {
    return dispatch(updateCoachingNotesPermissions('enable'));
  };
}

export function disableCoachingNotesPermissions() {
  return dispatch => {
    return dispatch(updateCoachingNotesPermissions('disable'));
  };
}

export function toggleShowArchivedAndUpdate(e, { checked }) {
  return dispatch => dispatch(fetchCoachingNotesSettings(checked));
}
